import { useRemainingTime } from '@/hooks/useRemainingTime'

type Props = {
  expiresAt: string
  onExpire?: () => void
}

export default function RemainingTimeDisplay({ expiresAt, onExpire }: Props) {
  const { deadlineTime, isExpired } = useRemainingTime(expiresAt, {
    onExpire,
  })

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 py-2 px-4 text-center text-sm ${
      isExpired ? 'bg-red-100 text-red-700' : 'bg-cyan-50 text-cyan-700'
    }`}>
      <span className="inline-flex items-center gap-2">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        予約枠の確保期限:
        <span className="font-bold">{isExpired ? '期限切れ' : `${deadlineTime}まで`}</span>
      </span>
    </div>
  )
}
